export enum RateLimitType {
  MODELS = 'MODELS',
  CONTACTS = 'CONTACTS',
  PROPOSALS = 'PROPOSALS',
}

export type RateLimits = {
  [k in keyof typeof RateLimitType]?: {
    limit: number;
    remaining: number;
  };
};

export type RateLimitsState = RateLimits;
